import { ReactElement, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router";
import {
  RootState,
  FetchReturn,
  ThunkDispatchType,
} from "../../store";
import CancelMeeting from "./CancelMeeting";
import { core } from "../../store/cabinetApi/core";
import { skipToken } from "@reduxjs/toolkit/query";
import { getLocalTimeZone } from "../../utils/scheduleUtils";
import { actions } from "../../store";
import { useWithDispatch } from "../../store/hooks";
import { useMountEffect } from "../../utils/hooks";


interface ComponentProps {
  externalId?: string,
  isPreview?: boolean,
  prefillName?: string;
  prefillEmail?: string;
  isFramed?: boolean;
  noCabPage?: boolean;
  isEnterpriseBook?: boolean;
  setBookingComplete?: (data?: {isIntroProcessComplete: boolean, shouldUpdateOrg: boolean}) => void;
}

type RouteParams = { meetingId: string, meetingToken: string };

type Props = ComponentProps;

const CancelMeetingContainer = ({
  externalId, isEnterpriseBook
}: Props): ReactElement => {
  const match = useParams<RouteParams>();
  const { meetingId, meetingToken } = match;
  const meetingExternalId = externalId || meetingId;

  const [loading, setLoading] = useState(false);

  const meetingInfo = useSelector((state: RootState) => meetingExternalId
    ? state.schedule.publicMeetings[meetingExternalId]
    : null);
  const { data: organization } = core.useCoreOrgPublicOrgByUserRetrieveQuery(
    !isEnterpriseBook && meetingInfo?.create_user.id
      ? meetingInfo.create_user.id.toString()
      : skipToken
  );

  const timezone = getLocalTimeZone();
  const cancelMeeting = useWithDispatch(actions.schedule.cancelExternalMeeting);
  
  const dispatch = useDispatch<ThunkDispatchType>();

  useMountEffect(() => {
    if (meetingExternalId && meetingToken) {
      setLoading(true);
      dispatch(actions.schedule.fetchMeetingExternal(
        meetingExternalId, meetingToken,
      )).finally(() => {
        setLoading(false);
      });
    }
  });

  return (
    <CancelMeeting
      loading={loading}
      meeting={meetingInfo}
      organization={organization}
      dateSet={null}
      currentTimeZone={timezone?.name || ''}
      leaders={[]}
      confirmed={false}
      name={meetingInfo?.create_user?.first_name || ''}
      handleCancelMeeting={async (message: string): Promise<FetchReturn | undefined> => {
        if (meetingInfo && meetingToken) {
          return await cancelMeeting(meetingInfo.id, meetingToken, message);
        }
        return { status: 400, data: { detail: "Missing meeting information", code: "missing_info" } };
      }}
    />
  );
};


export default CancelMeetingContainer;
